module.exports = __webpack_public_path__ + "img/newyear_reel_header.87dfcbdb.jpg";